'use strict';

var CompFaresChartWrapperDirective = function CompFaresChartWrapperDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/comp-fares-chart-wrapper.html'),
    controller: 'CompFaresChartWrapperController',
    scope: true,
    link: function link() {}
  };
};
CompFaresChartWrapperDirective.$inject = [];
module.exports = CompFaresChartWrapperDirective;